import { createActionConst } from '../../../utils/action.utils';

const MEETING_NAMESPACE = 'MEETING';

export const STORE_MEETING = createActionConst(MEETING_NAMESPACE, 'STORE_MEETING');
export const CLEAR_MEETING = createActionConst(MEETING_NAMESPACE, 'CLEAR_MEETING');
